var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foreground d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"playlist"},[_c('button',{staticClass:"red text-uppercase",attrs:{"data-toggle":"modal","data-target":"#buildPlaylistModal"}},[_vm._v(" "+_vm._s(_vm.$t("button.createPlaylist"))+" ")]),_c('Searching')],1),_c('build-playlist')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }